import { Component, Inject, Injectable } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntilDestroy } from "@ngneat/until-destroy";
import { IBankAccountViewModel } from "src/app/models/bank-account";
import { BankAccountService } from "src/app/services/http/bank-account.service";

@Injectable()
@Component({
    selector: 'app-bank-account-edit-create',
    templateUrl: './bank-account-edit-create.component.html',
    styleUrls: ['./bank-account-edit-create.component.scss']
  })
@UntilDestroy()
export class BankAccountEditCreateComponent{

    public bankAccount: IBankAccountViewModel;
    public isCreate: boolean = false;
    public userCanApproveOrRejectBankAccount: boolean = false;

    //Form components
    public bankAccountForm: UntypedFormGroup;
    public bankAccountName: UntypedFormControl;
    public bankAccountNumber: UntypedFormControl;
    public bankName: UntypedFormControl;
    public currency: UntypedFormControl;
    public investorName: UntypedFormControl;
    public reference: UntypedFormControl;
    public isVerified: UntypedFormControl

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<BankAccountEditCreateComponent>,
        private bankAccountService: BankAccountService,

    ){
        this.bankAccount = data.bankAccount;
        this.userCanApproveOrRejectBankAccount = data?.userCanApproveOrRejectBankAccount ? data.userCanApproveOrRejectBankAccount : false;

        this.createFormControls();
        this.createForm();
    }

    /**
     * Creates the initial skeleton of the form.
     */
    public createForm() : void {
        this.bankAccountForm = new UntypedFormGroup({
            bankAccountName: this.bankAccountName,
            bankAccountNumber: this.bankAccountNumber,
            bankName: this.bankName,
            currency: this.currency,
            investorName: this.investorName,
            reference: this.reference,
            isVerified: this.isVerified
        });
    }

    /**
     * Initialises the form controls.
     */
    private createFormControls() : void {
        this.bankAccountName = new UntypedFormControl({value: `${this.bankAccount.bankAccountName}`, disabled: true});
        this.bankAccountNumber = new UntypedFormControl({value: `${this.bankAccount.bankAccountNumber}`, disabled: true});
        this.bankName = new UntypedFormControl({value: `${this.bankAccount.bankName}`, disabled: true});
        this.currency = new UntypedFormControl({value: `${this.bankAccount.currencyCode ?? ''}`, disabled: true});
        this.investorName = new UntypedFormControl({value: `${this.bankAccount.investorEntityName}`, disabled: true});
        this.reference = new UntypedFormControl({value: `${this.bankAccount.reference ?? ''}`, disabled: true});
        this.isVerified = new UntypedFormControl({value: this.bankAccount.isVerified, disabled: true});
    }

    /**
     * Attempts to approve the given bank account.
     */
    public approveBankAccount(bankAccount: IBankAccountViewModel) : void {
        this.bankAccountService.approveBankAccount(bankAccount.investorEntityId, bankAccount.bankId);
        this.closeDialog();
    }

    /**
     * Attempts to reject the given bank account.
     */
    public rejectBankAccount(bankAccount: IBankAccountViewModel) : void {
        this.bankAccountService.rejectBankAccount(bankAccount.investorEntityId, bankAccount.bankId);
        this.closeDialog();
    }

    public closeDialog() {
        this.dialogRef.close();
    }
}